//
//  FormButton.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import React from "react";
import Box from "@mui/material/Box";

type FormButtonProps = {
  children: React.ReactNode;
  button: React.ReactNode;
};

export const FormButton: React.FC<FormButtonProps> = ({ children, button }) => (
  <Box display="flex" flexDirection="column" gap={2}>
    {children}
    <Box display="flex" justifyContent="flex-end">
      {button}
    </Box>
  </Box>
);
